<template>
  <div class="template-detail__header">
    <!-- template control -->
    <div v-if="!isMobile" class="template-detail__header-control">
      <!-- back link -->
      <AppRouterLink exact :to="{ name: 'templates-listing' }" text="Volver">
        <AppIcon icon="far fa-angle-left" />
      </AppRouterLink>
    </div>
    <!-- template title -->
    <div class="template-detail__header-title">
      <!-- back link mobile -->
      <AppRouterLink v-if="isMobile" exact :to="{ name: 'templates-listing' }">
        <AppIcon icon="far fa-angle-left" />
      </AppRouterLink>
      <AppHeading :text="template.title" />
    </div>
    <!-- template actions -->
    <div v-if="!isMobile" class="template-detail__header-actions">
      <!-- variant toggle -->
      <AppRouterLink
        v-if="!isMobile"
        v-allowed.editor
        class="template-detail__actions-edit"
        exact
        :to="{ name: 'template-edit' }"
        text="Editar"
      >
        <AppIcon icon="far fa-edit" />
      </AppRouterLink>
      <!-- unpublish button -->
      <TemplatesUnpublishButton v-allowed.editor v-if="!isMobile" :disabled="!mainIsPublished" />
    </div>
    <!-- mobile menu -->
    <AppBurgerMenu v-if="isMobile" open-icon="fas fa-ellipsis-h" v-allowed.editor>
      <template #menu-content>
        <TemplatesMobileMenu :template="template" variant="details" />
      </template>
    </AppBurgerMenu>
  </div>
</template>

<script>
// Utilities
import MobileBreakpointControl from 'Mixins/MobileBreakpointControl'
// Components
import AppIcon from 'Ui/AppIcon'
import AppHeading from 'Ui/AppHeading'
import AppRouterLink from 'Ui/AppRouterLink'
import AppBurgerMenu from 'Ui/AppBurgerMenu'
import TemplatesMobileMenu from 'Modules/Templates/components/TemplatesMobileMenu'
import TemplatesUnpublishButton from 'Modules/Templates/components/TemplatesUnpublishButton'

export default {
  name: 'TemplateEditHeader',

  components: {
    AppIcon,
    AppHeading,
    AppRouterLink,
    AppBurgerMenu,
    TemplatesMobileMenu,
    TemplatesUnpublishButton,
  },

  props: {
    template: {
      type: Object,
      required: true,
    },
  },

  mixins: [MobileBreakpointControl],

  data() {
    return {
      mobileBreakpoint: 900,
    }
  },

  computed: {
    mainTemplate() {
      return this.$store.getters['templates/getTemplate'](this.template.card_id)[0]
    },
    mainIsPublished() {
      return !!this.template.main
    },
  },
}
</script>

<style src="@/modules/Templates/assets/css/template-detail-header.css" scoped></style>
<style scoped>
.template-detail__header-title .app-link {
  font-size: 20px;
  margin: 5px 10px 0 10px;
}
</style>
